import React from 'react';

import { useAction } from 'core/store/store';

import { makeResetPasswordPhoneSubmitAction } from 'state/auth/actions';

import { PasswordResetPhoneForm } from '../../../forms/PasswordResetPhoneForm/PasswordResetPhoneForm';

export const PhoneForm = () => {
    const action = useAction();
    return (
        <PasswordResetPhoneForm
            onSubmit={data => {
                const { phone } = data;
                action(makeResetPasswordPhoneSubmitAction, phone);
            }}
        />
    );
};
